export default __webpack_public_path__ + "static/media/rival-shield.18dd9f33.svg";